import { render, staticRenderFns } from "./HomeFavoriteButton.vue?vue&type=template&id=40cc059e&"
import script from "./HomeFavoriteButton.vue?vue&type=script&lang=js&"
export * from "./HomeFavoriteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports